module.exports = __webpack_public_path__ + "static/media/grainger-logo-text.5b780c5a.svg";